module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-preact/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/gatsby-plugin-catch-links/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"KukkaRoosa","short_name":"KukkaRoosa","start_url":"https://ekukka.testitili.com","scope":"https://ekukka.testitili.com","icon":"src/images/favicon.png","legacy":true,"display":"browser"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
